<template>
  <div :class="$style.loadingScreen" role="status">
    <p :class="$style.label">Betöltés…</p>
  </div>
</template>

<style module>
.loadingScreen {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 100svh;
}

.label {
  margin: 0;
  font-size: var(--font-size-title);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-muted);
}
</style>
